/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { parseISO } from "date-fns";
import { format } from "date-fns-tz";
import styled from "styled-components";
import { useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";

const StyledListItem = styled(ListItem)`
  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

const StyledNoteContents = styled(({ theme, ...props }) => (
  <Typography {...props} />
))`
  margin: 0;
  padding: 1px 1px;
`;

const StyledBoldLabelTypography = styled(Typography)`
  font-weight: 500 !important;
`;

function TooltipNote({ note }) {
  const theme = useTheme();
  const createDateTime = parseISO(note.createTime + "Z");
  const formattedCreateTime = format(createDateTime, "HH:mm (z)");
  const formattedCreateDate = format(createDateTime, "MM/dd");

  return (
    <StyledListItem disableGutters>
      <Grid container>
        <Grid item xs={12}>
          <Typography align={"left"} component="div" variant="caption">
            {note.author} at {formattedCreateTime} on {formattedCreateDate}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            alignItems="center"
            container
            wrap="nowrap"
            justify={"flex-start"}
          >
            <Grid
              item
              style={{
                order: 1,
              }}
            >
              <StyledNoteContents theme={theme}>
                {note.rows?.length
                  ? note.rows
                      .sort((a, b) => a.sequence - b.sequence)
                      .map((row) => (
                        <Typography key={row.noteRowsId}>
                          <StyledBoldLabelTypography display="inline">
                            {row.displayLabel}:{" "}
                          </StyledBoldLabelTypography>
                          {row.contents}
                        </Typography>
                      ))
                  : note.contents}
              </StyledNoteContents>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledListItem>
  );
}

export default TooltipNote;
